import { render, staticRenderFns } from "./Layanan.vue?vue&type=template&id=3b6c3346"
import script from "./Layanan.vue?vue&type=script&lang=js"
export * from "./Layanan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports